import { render, staticRenderFns } from "./timerMinute.vue?vue&type=template&id=53ae085c&"
import script from "./timerMinute.vue?vue&type=script&lang=ts&"
export * from "./timerMinute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports